import React, { useEffect } from 'react'
import Bredcom from '../../Bredcom/Main'
import Header from '../../headerone/Main'
import Blog from '../../menhome/Blog'
import Newlast from '../../menhome/Newlast'
import Reviewboard from '../mencreviewboard/Reviewboard'


function Main() {

  useEffect(() => {
    document.getElementById("title").innerHTML="Civilian Complaints & Review Board";
  }, [])

  return (
    <>
        <Header/>

        <div className="page-wrapper">
        <Bredcom 
            subtitle="Home"
            title="review board"
            subtitledown="Review Board"
           />
            <Reviewboard/>
            <Blog/>
            <Newlast/>
        </div>
    </>
  )
}

export default Main